import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useNoIndex } from "@/lib/seo";
import { useSeo } from "@/lib/seo";

const PaymentCancel = () => {
  useSeo({ title: "Paiement annulé · Entre Les Mondes", description: "", noindex: true });
  useNoIndex();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");

  useEffect(() => {
    document.title = "Paiement annulé — Entre les Mondes";
    if (sessionId) api.paymentCancel(sessionId).catch(() => {});
  }, [sessionId]);

  return (
    <div className="pt-44 pb-32 text-center max-w-xl mx-auto px-6" data-testid="payment-cancel">
      <XCircle className="w-14 h-14 text-fumee/60 mx-auto mb-6" />
      <p className="eyebrow mb-4">Paiement annulé</p>
      <h1 className="font-serif text-3xl lg:text-4xl text-bark leading-tight">Rien n'a été débité.</h1>
      <p className="text-fumee mt-5 leading-relaxed">
        Votre réservation ou votre commande n'a pas été finalisée et la place a été libérée. Vous pouvez reprendre quand vous le souhaitez.
      </p>
      <div className="mt-10 flex flex-wrap justify-center gap-4">
        <Link to="/agenda" data-testid="payment-cancel-agenda"
          className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-earth text-sand text-sm hover:bg-terra hover:text-earth transition-colors duration-300">
          Retour à l'agenda <ArrowRight className="w-4 h-4" />
        </Link>
        <Link to="/panier" data-testid="payment-cancel-panier"
          className="inline-flex items-center gap-3 px-8 py-4 rounded-full border border-wood/30 text-bark text-sm hover:border-terra hover:text-terra transition-colors duration-300">
          Mon panier
        </Link>
      </div>
    </div>
  );
};

export default PaymentCancel;
